import React from "react";

// Mui
import Fade from "@mui/material/Fade";
import Grid from "@mui/material/Grid2";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";

// Mui Styles
import getDateRange from "@/lib/getDateRange";
import { StyledPaper } from "@/styles/mui/globalStyles";
import { TableListTheme } from "@/styles/mui/tableListTheme";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { cheerfulFiestaPalette } from "@mui/x-charts/colorPalettes";
import { LineChart } from "@mui/x-charts/LineChart";

import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SearchIcon from "@mui/icons-material/Search";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import LoadingButton from "@mui/lab/LoadingButton";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Autocomplete from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import OutlinedInput from "@mui/material/OutlinedInput";
import Select from "@mui/material/Select";
// Navigate
import { ButtonSendTheme } from "@/styles/mui/tableListTheme";
// Components
import ProductAutoComplete from "@/components/Filter/productAutocomplete";
import Layout from "@/components/layout";
import Title from "@/components/title";
import Stack from "@mui/material/Stack";

// Fetch
import {
  getAreaAndDistrict,
  getProducts,
  getProductTrend,
} from "@/fetch/fetchStatistics";

import { getRegionOptions } from "@/fetch/fetchWork";
// Moment
import _ from "lodash";
import moment from "moment";
import "moment/locale/zh-hk";
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
const ProductTrendChartPage = (props) => {
  const { open, setOpen } = props;

  // Theme
  const theme = createTheme({
    components: {
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: 16,
          },
        },
      },
    },
  });

  // Navigate
  const [selectedDate, setSelectedDate] = React.useState({
    startDate: moment().startOf("month").format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  });
  const [districtOptions, setDistrictOptions] = React.useState([]);
  const [areaOptions, setAreaOptions] = React.useState([]);
  const [productOptions, setProductOptions] = React.useState([]);
  const [shopOptions, setShopOptions] = React.useState([]);
  const [filterShopOptions, setFilterShopOptions] = React.useState([]);
  const [filterAreaOptions, setFilterAreaOptions] = React.useState([]);
  const [isLoading, setLoading] = React.useState(false);
  const [dateGrouping, setDateGrouping] = React.useState("day");
  const [showChart, setShowChart] = React.useState(false);
  const [expanded, setExpanded] = React.useState(true);
  const [chartData, setChartData] = React.useState({
    series: [],
    xAxis: [],
    height: 500,
  });
  const [selectedShopName, setSelectedShopName] = React.useState([]);
  const [dateRange, setDateRange] = React.useState("7 days");
  const [showRange, setShowRange] = React.useState(false);
  const [filter, setFilter] = React.useState({
    dateRange: "7 days",
    dateGrouping: "day",
    groupBy: "work_district",
    startDate: null,
    endDate: null,
    district: [],
    area: [],
    shop: [],
    product: null,
  });
  const [openStartDatePicker, setOpenStartDatePicker] = React.useState(false);
  const [openEndDatePicker, setOpenEndDatePicker] = React.useState(false);
  const valueFormatter = (value) => `$${new Intl.NumberFormat().format(value)}`;

  const fetchProductSales = async () => {
    const { data: sales } = await getProductTrend(filter);

    let xAxis = [{ data: [], scaleType: "point", id: "axis1" }];
    const series = [];
    let labels = [];
    setLoading(false);
    switch (dateRange) {
      case "7 days":
      case "30 days":
      case "6 months":
      case "1 years":
        const splitDateRange = dateRange.split(" ");
        labels = getDateRange(
          moment().subtract(splitDateRange[0], splitDateRange[1]),
          moment(),
          dateGrouping
        );
        break;
      case "custom":
        labels = getDateRange(filter.startDate, filter.endDate, dateGrouping);
        break;
      default:
        break;
    }
    xAxis[0].data = labels;
    const groupByProduct = _.groupBy(sales, "work_label");
    _.forEach(groupByProduct, (product, key) => {
      const groupByLabel = _.groupBy(product, "tx_date");
      const seriesData = {
        id: key,
        data: [],
        label: key,
        stack: "total",
        area: true,
        showMark: false,
        highlightScope: {
          highlighted: "item",
        },
        valueFormatter,
      };
      _.forEach(labels, (label) => {
        if (groupByLabel[label] === undefined) {
          seriesData.data.push(0);
        } else {
          seriesData.data.push(
            _.sumBy(groupByLabel[label], (label) => parseInt(label.total))
          );
        }
        // series.push({});
      });
      series.push(seriesData);
    });
    setChartData({
      series,
      xAxis,
      height: 500,
      colors: cheerfulFiestaPalette,
    });
    console.log({ series, xAxis });
    setShowChart(true);
    setExpanded(false);
    //console.log("xAxis", xAxis);
  };

  const handleGroupingChange = (e) => {
    setFilter((prev) => {
      return {
        ...prev,
        groupBy: e.target.value,
      };
    });
  };
  const handleDateGroupChange = (e) => {
    setDateGrouping(e.target.value);
    setFilter((prev) => {
      return {
        ...prev,
        dateGrouping: e.target.value,
      };
    });
  };
  const handDateRangeChange = (e) => {
    if (e.target.value === "custom") {
      setShowRange(true);
      setOpenStartDatePicker(true);
      setFilter((prev) => {
        return {
          ...prev,
          dateRange: e.target.value,
        };
      });
    } else {
      setDateGrouping(e.target.value.includes("days") ? "day" : "month");

      setFilter((prev) => {
        return {
          ...prev,
          dateRange: e.target.value,
          dateGrouping: e.target.value.includes("days") ? "day" : "month",
        };
      });
      setShowRange(false);
    }
    setDateRange(e.target.value);
  };
  const handleDistricthange = (e) => {
    if (e.target.value.includes("ALL")) {
      const allDistrictOptions = _.map(districtOptions, "district_id");

      setFilter((prev) => {
        return {
          ...prev,
          district:
            e.target.value.length - 1 === allDistrictOptions.length
              ? []
              : allDistrictOptions,
          area: _.map(areaOptions, "area_id"),
          shop: _.map(shopOptions, (a) => a.id),
        };
      });
      setFilterAreaOptions(areaOptions);
      setFilterShopOptions(shopOptions);
      setSelectedShopName(_.map(shopOptions, "work_area_id"));
    } else {
      const filterArea = areaOptions.filter((areaOption) =>
        e.target.value.includes(areaOption.district_id)
      );
      const filterShop = shopOptions.filter((shopOption) =>
        e.target.value.includes(shopOption.work_district_id)
      );
      setFilter((prev) => {
        return {
          ...prev,
          district: e.target.value,
          area: _.map(filterArea, (a) => a.area_id),
          shop: _.map(filterShop, (a) => a.id),
        };
      });
      setFilterAreaOptions(filterArea);
      setFilterShopOptions(filterShop);
      setSelectedShopName(_.map(filterShop, "work_area_id"));
    }
  };
  const handleAreaChange = (e) => {
    if (e.target.value.includes("ALL")) {
      const filterShop = shopOptions.filter((shopOption) =>
        filter.area.includes(shopOption.work_area_id)
      );
      setFilter((prev) => {
        return {
          ...prev,
          area:
            e.target.value.length - 1 === filterAreaOptions.length
              ? []
              : _.map(filterAreaOptions, (a) => a.area_id),
          shop: _.map(shopOptions, (a) => a.id),
        };
      });
      setFilterShopOptions(filterShop);
      setSelectedShopName(_.map(filterShop, "work_area_id"));
    } else {
      const filterShop = shopOptions.filter((shopOption) =>
        e.target.value.includes(shopOption.work_area_id)
      );
      setFilter((prev) => {
        return {
          ...prev,
          area: e.target.value,
          shop: _.map(filterShop, (a) => a.id),
        };
      });
      setFilterShopOptions(filterShop);
      setSelectedShopName(_.map(filterShop, "work_area_id"));
    }
  };

  //Fetch all
  const fetchAll = async () => {
    const { data: locations } = await getAreaAndDistrict();
    const { data: products } = await getProducts();
    const { data: workOptions } = await getRegionOptions();
    const district = _.map(_.uniqBy(workOptions, "district_id"), (option) => ({
      district_id: option.district_id,
      district_name: option.district_name,
    }));
    setDistrictOptions(district);
    //await fetchProductSales();
    setProductOptions(products);

    setFilter((prev) => {
      return {
        ...prev,
        district: _.map(district, "district_id"),
        area: _.map(workOptions, "area_id"),
      };
    });
    setShopOptions(locations);
    setFilterShopOptions(locations);

    setAreaOptions(workOptions);
    setFilterAreaOptions(workOptions);

    setSelectedShopName(_.map(locations, "work_name"));
  };
  React.useEffect(() => {
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDate]);

  return (
    <Layout header="DailyPage" selectedIndex={33} open={open} setOpen={setOpen}>
      <Title
        title="產品走勢圖"
        // children={
        //   <IconButton component="label" onClick={() => exportSalesReport()}>
        //     <DownloadIcon />
        //   </IconButton>
        // }
      />
      <ThemeProvider theme={theme}>
        <Accordion
          expanded={expanded}
          style={{ flexGrow: 1, display: "block" }}
        >
          <AccordionSummary
            expandIcon={
              <ExpandMoreIcon
                onClick={() => setExpanded(!expanded)}
              ></ExpandMoreIcon>
            }
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <SearchIcon></SearchIcon>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={2}>
              <Grid
                size={{
                  xs: 12,
                  md: 3,
                  lg: 3
                }}>
                <Grid container spacing={2}>
                  <Grid
                    size={{
                      xs: 12,
                      md: 8,
                      lg: 8
                    }}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        時間
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={dateRange}
                        label="date"
                        onChange={handDateRangeChange}
                      >
                        <MenuItem value={"7 days"}>最近7天</MenuItem>
                        <MenuItem value={"30 days"}>最近30天</MenuItem>
                        <MenuItem value={"6 months"}>最近半年</MenuItem>
                        <MenuItem value={"1 years"}>最近1年</MenuItem>
                        <MenuItem value={"custom"}>自訂</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid
                    size={{
                      xs: 12,
                      md: 4,
                      lg: 4
                    }}>
                    <FormControl fullWidth>
                      <InputLabel id="dateGrouping-select-label">
                        分佈
                      </InputLabel>
                      <Select
                        labelId="dateGrouping-select-label"
                        id="dateGrouping-select"
                        value={dateGrouping}
                        label="date"
                        onChange={handleDateGroupChange}
                      >
                        <MenuItem
                          disabled={
                            !dateRange.includes("days") &&
                            dateRange !== "custom"
                          }
                          value={"day"}
                        >
                          每日
                        </MenuItem>
                        <MenuItem
                          disabled={dateRange.includes("days")}
                          value={"month"}
                        >
                          月份
                        </MenuItem>
                        <MenuItem
                          disabled={dateRange.includes("days")}
                          value={"quarter"}
                        >
                          季度
                        </MenuItem>
                        <MenuItem
                          disabled={dateRange.includes("days")}
                          value={"year"}
                        >
                          年份
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>

                {showRange && (
                  <Grid container spacing={2} sx={{ mt: 0 }}>
                    <Grid
                      size={{
                        xs: 12,
                        md: 6,
                        lg: 6
                      }}>
                      <DatePicker
                        disableFuture
                        open={openStartDatePicker}
                        maxDate={filter.endDate}
                        label="開始"
                        value={filter.startDate}
                        onChange={(newValue) => {
                          setFilter((prev) => {
                            return {
                              ...prev,
                              startDate: moment(newValue).format("YYYY-MM-DD"),
                            };
                          });
                          setOpenEndDatePicker(true);
                          setOpenStartDatePicker(false);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            sx={{ width: "100%" }}
                            onClick={(e) => {
                              setOpenEndDatePicker(false);
                              setOpenStartDatePicker(true);
                            }}
                          />
                        )}
                      />
                    </Grid>
                    <Grid
                      size={{
                        xs: 12,
                        md: 6,
                        lg: 6
                      }}>
                      <DatePicker
                        disableFuture
                        open={openEndDatePicker}
                        minDate={filter.startDate}
                        label="結束"
                        value={filter.endDate}
                        onChange={(newValue) => {
                          setFilter((prev) => {
                            return {
                              ...prev,
                              endDate: moment(newValue).format("YYYY-MM-DD"),
                            };
                          });
                          setOpenEndDatePicker(false);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            sx={{ width: "100%" }}
                            onClick={(e) => {
                              setOpenEndDatePicker(true);
                              setOpenStartDatePicker(false);
                            }}
                          />
                        )}
                      />
                    </Grid>
                  </Grid>
                )}
              </Grid>
              <Grid
                size={{
                  xs: 12,
                  md: 2,
                  lg: 2
                }}>
                <Grid
                  size={{
                    xs: 12,
                    md: 12,
                    lg: 12
                  }}>
                  <FormControl fullWidth>
                    <InputLabel id="district-select-label">地區</InputLabel>
                    <Select
                      labelId="district-select-label"
                      id="district-select"
                      value={filter.district}
                      label="district"
                      multiple
                      onChange={handleDistricthange}
                      renderValue={(selected) =>
                        selected.length === districtOptions.length
                          ? "所有地區"
                          : `已選擇${selected.length}個`
                      }
                      input={<OutlinedInput label="地區" />}
                    >
                      <MenuItem key={"ALL"} value={"ALL"}>
                        <Checkbox
                          checked={
                            filter.district.length === districtOptions.length
                          }
                        />
                        <ListItemText primary={"所有地區"} />
                      </MenuItem>
                      {_.map(districtOptions, (item, index) => (
                        <MenuItem key={index} value={item.district_id}>
                          <Checkbox
                            checked={
                              filter.district.find(
                                (d) => d === item.district_id
                              ) !== undefined
                            }
                          />
                          <ListItemText primary={item.district_name} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid
                  sx={{ mt: 2 }}
                  size={{
                    xs: 12,
                    md: 12,
                    lg: 12
                  }}>
                  <FormControl fullWidth>
                    <InputLabel id="area-select-label">區域</InputLabel>
                    <Select
                      labelId="area-select-label"
                      id="area-select"
                      value={filter.area}
                      multiple
                      label="area"
                      onChange={handleAreaChange}
                      renderValue={(selected) =>
                        selected.length === filterAreaOptions.length
                          ? "所有區域"
                          : `已選擇${selected.length}個`
                      }
                      input={<OutlinedInput label="區域" />}
                    >
                      <MenuItem key={"ALL"} value={"ALL"}>
                        <Checkbox
                          checked={
                            filter.area.length === filterAreaOptions.length
                          }
                        />
                        <ListItemText primary={"所有區域"} />
                      </MenuItem>
                      {_.map(filterAreaOptions, (item, index) => (
                        <MenuItem key={index} value={item.area_id}>
                          <Checkbox
                            checked={
                              filter.area.find((d) => d === item.area_id) !==
                              undefined
                            }
                          />
                          <ListItemText primary={item.area_name} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                {/* <Grid item xs={12} md={12} lg={12}></Grid> */}
              </Grid>
              <Grid
                size={{
                  xs: 12,
                  md: 6,
                  lg: 6
                }}>
                <Grid
                  size={{
                    xs: 12,
                    md: 12,
                    lg: 12
                  }}>
                  <FormControl fullWidth>
                    <Autocomplete
                      disableCloseOnSelect
                      limitTags={4}
                      groupBy={(option) =>
                        `${option.district_name}-${option.area_name}`
                      }
                      multiple
                      getOptionKey={(option) => option.id}
                      getOptionLabel={(option) =>
                        `${option.work_name}(${option.work_shortcode})`
                      }
                      onChange={(event, newValue) => {
                        setFilter((prev) => {
                          return {
                            ...prev,
                            shop: _.map(newValue, "id"),
                          };
                        });
                        setSelectedShopName(_.map(newValue, "work_name"));
                      }}
                      id="shop-combo-box"
                      options={filterShopOptions}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          error={
                            filter.groupBy === "work_shortcode,work_name" &&
                            filter.shop.length <= 0
                          }
                          helperText={
                            filter.groupBy === "work_shortcode,work_name" &&
                            filter.shop.length <= 0
                              ? "請選擇店鋪"
                              : ""
                          }
                          label="店鋪"
                        />
                      )}
                      renderOption={(props, option, { selected }) => {
                        return (
                          <li {...props} key={`shop-${option.work_shortcode}`}>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={selected}
                            />
                            {option.work_name}({option.work_shortcode})
                          </li>
                        );
                      }}
                    />
                  </FormControl>
                </Grid>

                <Grid
                  sx={{ mt: 2 }}
                  size={{
                    xs: 12,
                    md: 12,
                    lg: 12
                  }}>
                  <FormControl fullWidth>
                    <ProductAutoComplete
                      productOptions={productOptions}
                      handleOnChange={(event, newValue) => {
                        setFilter((prev) => {
                          return {
                            ...prev,
                            product: newValue ? newValue.id : null,
                          };
                        });
                      }}
                      error={!filter.product}
                    ></ProductAutoComplete>
                  </FormControl>
                </Grid>
              </Grid>
              <Grid
                size={{
                  xs: 12,
                  md: 1,
                  lg: 1
                }}>
                <Grid
                  size={{
                    xs: 12,
                    md: 12,
                    lg: 12
                  }}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      Group By
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={filter.groupBy}
                      label="date"
                      onChange={handleGroupingChange}
                    >
                      <MenuItem value={"work_district"}>地區</MenuItem>
                      <MenuItem value={"work_area"}>區域</MenuItem>
                      <MenuItem value={"work_shortcode,work_name"}>
                        店鋪
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid
                  sx={{ mt: 2 }}
                  size={{
                    xs: 12,
                    md: 12,
                    lg: 12
                  }}>
                  <ThemeProvider theme={ButtonSendTheme}>
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <LoadingButton
                        size="small"
                        onClick={() => {
                          setLoading(true);
                          fetchProductSales();
                        }}
                        endIcon={<SearchOutlinedIcon fontSize="small" />}
                        loading={isLoading}
                        disabled={
                          !filter.product ||
                          (filter.groupBy === "work_shortcode,work_name" &&
                            filter.shop.length <= 0)
                        }
                        loadingPosition="end"
                        variant="contained"
                      >
                        搜尋
                      </LoadingButton>
                    </div>
                  </ThemeProvider>
                </Grid>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </ThemeProvider>
      {showChart && (
        <Fade in={true} mountOnEnter unmountOnExit>
          <StyledPaper page={"yes"}>
            <ThemeProvider theme={TableListTheme}></ThemeProvider>
            <Stack
              direction={{ xs: "column", md: "row" }}
              sx={{ width: "100%" }}
            >
              <Box sx={{ flexGrow: 1 }}>
                <LineChart
                  margin={{ right: 5, left: 80 }}
                  sx={{
                    "& .MuiAreaElement-series-Germany": {
                      fill: "url('#myGradient')",
                    },
                  }}
                  grid={{ vertical: true, horizontal: true }}
                  {...chartData}
                  // onItemClick={(event, d) => setItemData(d)}
                  // onAxisClick={(event, d) => setAxisData(d)}
                >
                  <defs>
                    <linearGradient
                      id="myGradient"
                      gradientTransform="rotate(90)"
                    >
                      <stop offset="5%" stopColor="gold" />
                      <stop offset="95%" stopColor="red" />
                    </linearGradient>
                  </defs>
                </LineChart>
              </Box>
            </Stack>
          </StyledPaper>
        </Fade>
      )}
    </Layout>
  );
};

export default ProductTrendChartPage;
